import Hero from './components/Hero';
import FeaturedComics from './components/FeaturedComics';
import CategorySection from './components/CategorySection';
import RankingSection from './components/RankingSection';
import LatestUpdates from './components/LatestUpdates';

export default function Home() {
  return (
    <main>
      <Hero />
      <FeaturedComics />
      <CategorySection />
      <RankingSection />
      <LatestUpdates />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "香蕉文化漫画网 - 首页",
            "url": "https://www.xiangjiaowenhua.com/",
            "description": "香蕉文化漫画网提供下拉式、翻页与弹窗等多种阅读模式，流畅看免费全集漫画，海量韩漫日漫国漫资源",
            "isPartOf": {
              "@type": "WebSite",
              "name": "香蕉文化漫画网"
            }
          })
        }}
      />
    </main>
  );
}